<template lang="pug">
  td
    .initial(v-if="dissection.loading || dissection.error || !bv")
      .loading.text-muted(v-if="dissection.loading") loading...
      .empty(v-else)

    .result(v-else)
      template(v-if="cellType == 'resolvedCode'") {{bv.code}}

      template(v-else-if="cellType == 'ref' && status !== 'INVALID'")
        router-link(:to="{ name: 'order', params: {id: bv.orderId }}") {{bv.orderId}}
        |, {{bv.codeIndex}}

      template(v-else-if="cellType == 'codeBundle' && bv.codeBundle")
        GenericTable.bundle-table
          tr(slot="thead")
            th Index
            th Code
            th Type
          tr(v-for="i in bv.codeBundle.items")
            td {{i.codeIndex}}
            td.kzcode-default(@click="dissectCodeBundle(i.code)") {{i.code}}
            td {{i.codeType}}

      template(v-else-if="cellType == 'creator' && creator") {{creator.organization.name}} - {{creator.username}}

      template(v-else-if="cellType == 'orderOwner' && bv.owner") {{orderOwner}}

      template(v-else-if="cellType == 'codeLength'") {{bv.code.length}}

      template(v-else-if="cellType == 'section' && bv.section")
        router-link(:to="{ name: 'section', params: { orderId: bv.orderId, sectionId: bv.section.id }}") {{bv.section.id}}

      template(v-else-if="cellType == 'validations'") {{bv.validationCount}} of {{maxValidations}}

      template(v-else-if="cellType == 'product' && bv.product") {{bv.product.name}}

      template(v-else-if="cellType == 'configuration' && bv.codeConfiguration")
        | {{bv.codeConfiguration.id}} - {{bv.codeConfiguration.name}}

      template(v-else-if="cellType == 'channels' && bv.channels")
        .channel(v-for="c in bv.channels") {{c.type}} - {{c.name}}

      template(v-else-if="cellType == 'codeFlags' && bv.codeFlags")
        .code-flag(v-for="f in bv.codeFlags") {{f.id}}: {{f.name}}

      template(v-else-if="cellType == 'organization' && bv.organization")
        span {{bv.organization.name}}
      template(v-else-if="cellType == 'sscc' && bv.sscc") {{trimmedSscc}}

      .not-applicable.text-muted(v-else) n/a

</template>
<script>
import GenericTable from '@/components/common/GenericTable'

export default {
  props: ['dissection', 'cellType'],
  methods: {
    dissectCodeBundle(code) {
      this.$emit('dissectCodeBundle', code)
    }
  },
  computed: {
    creator() {
      return this.dissection.creator
    },
    bv() {
      return this.dissection.batchValidationResult
    },
    status() {
      return this.bv.result.status
    },
    maxValidations() {
      return this.bv.maxValidationCount ? this.bv.maxValidationCount : '∞'
    },
    orderOwner() {
      const { owner } = this.bv
      let key = ''
      if (owner.organization) {
        key = 'organization'
      } else if (owner.user) {
        key = 'user'
      } else if (owner.group) {
        key = 'group'
      } else {
        return `Err: owner prop does not contain one of [organization, user, group]: ${JSON.stringify(owner)}`
      }
      const entity = this.bv.owner[key]
      return `${key} - ${entity.name}`
    },
    trimmedSscc() {
      return this.bv && this.bv.sscc ? this.bv.sscc.replace(/ /g, '') : ''
    }

  },
  components: {
    GenericTable
  }
}
</script>

<style lang="scss">
.bundle-table {
  td, table, th {
    border: none !important;
    padding-left: 0 !important;
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }
  th {
    color: black !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/dissector/components/GenericCell.vue